<template>
  <div style="width: 100%">
    <div style="position: absolute;top: 0;width: 100px;height: 60px;cursor: pointer;z-index: 999" @click="testLogin">
    </div>
    <div v-if="marqueeMessages.length > 0" @click="jumpLinkTop(marqueeMessages[currentIndex].url)"
      style="background-color: #137D5A; width: 100%; height: 36px; text-align: center; line-height: 36px; perspective: 1000px;cursor: pointer">
      <transition name="flip" mode="out-in">
        <div :key="currentIndex" class="flip-card">
          <div class="flip-content">
            <span style="color: #fff; font-size: 14px;">{{ marqueeMessages[currentIndex].title }}</span>
          </div>
        </div>
      </transition>
    </div>

    <div style="width: 100%;display: flex;justify-content: center;background-color: #fff;z-index: 9">
      <!--      <img v-if="!isCreator && isHomePage" @click="jumpReg" :style="'position: fixed;cursor: pointer;top: 530px; right: 20px' " src="../assets/home/creatorFlex.png">-->
      <div v-if="isRightLinkShow"
        style="position: fixed;cursor: pointer;top: 530px; right: 20px;box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);display: flex;align-items: center;justify-content: center;flex-direction: column;z-index: 8;background-color: #fff;color: #1AB07F; border-radius: 4px;">
        <div v-if="!isCreator" @click="jumpReg" class="hover-effect"
          style="display: flex;justify-content: center;align-items: center;flex-direction: column;width: 60px;height: 60px;">
          <img src="../assets/home/kaidian1.png">
          <div style="font-size:12px;">{{ t('common.open_shop') }}</div>
        </div>
        <div class="hover-effect3"
            style="display: flex;justify-content: center;align-items: center;flex-direction: column;width: 60px;height: 60px;position: relative;"
            @mouseenter="showQRCode = true" @mouseleave="showQRCode = false">
            <img class="kf-img" src="../assets/home/kf1.png" />
            <div class="kf-text" style="font-size:12px;">{{ t('common.customer_service') }}</div>
            <!-- 新增的二维码图片 -->
            <div class="qr-code-overlay" :class="{ 'qr-code-visible': showQRCode }">
              <div style="font-size: 16px;font-weight: bold">{{ t('common.scan_qr') }}</div>
              <img src="../assets/home/qrcode.png" alt="二维码" style="width: 100%; margin-top: 5px;">
              <div style="font-size: 12px;color: #999">{{ t('common.work_time') }}</div>
            </div>
          </div>
        <div class="hover-effect2" @click="goTop"
          style="display: flex;justify-content: center;align-items: center;flex-direction: column;width: 60px;height: 60px;">
          <img src="../assets/home/dingbu1.png">
          <div style="font-size:12px;">{{ t('common.top') }}</div>
        </div>
      </div>

      <div class="menu-box">
        <img @click="() => { changeButton(0, menuList[0]) }" src="../assets/logo.png"
          style="cursor: pointer;height: 36px">
        <div>
          <el-input v-model="searchString" style="width: 800px" :placeholder="t('header.search_placeholder')" size="large">
            <template #suffix>
              <div class="search-button"
                style="width: 34px;height: 34px;border-radius: 100%;background-color: #1AB07F;cursor: pointer">
                <img src="../assets/image/search.png" style="margin: 7px;">
              </div>
            </template>
          </el-input>
        </div>
        <div style="display: flex;align-items: center">
          <el-select v-model="language" style="width: 70px;height: 32px;margin-right: 16px">
            <el-option label="zh-CN" value="zh-CN">
              <div style="display: flex;align-items: center">
                <img src="../assets/country/ZH.png" />
                <div style="margin-left: 10px">CHN-ZH</div>
              </div>
            </el-option>
            <el-option label="en-US" value="en-US">
              <div style="display: flex;align-items: center">
                <img src="../assets/country/EN.png" />
                <div style="margin-left: 10px">USA-EN</div>
              </div>
            </el-option>
            <template #label>
              <div style="display: flex;align-items: center;">
                <img :src="language === 'en-US' ? require('../assets/country/EN.png') : require('../assets/country/ZH.png')" />
              </div>
            </template>
          </el-select>
          <el-button color="#1AB07F" v-if="!isLogin" @click="openLoginPop"
            style="width: 100px;height: 32px">{{ t('header.login') }}</el-button>
          <el-dropdown v-else @command="handleCommand">
            <span class="el-dropdown-link">
              <div style="display: flex;align-items: center">
                <div @click.stop="handleCommand(0)"
                  style="width: 40px;height: 40px;border-radius: 100%;overflow: hidden;background-color: #F2F2F2;cursor: pointer">
                  <img v-if="userInfo.image" style="width: 100%" :src="userInfo.image">
                  <img v-else src="../assets/image/user.png" alt="">
                </div>
                <!--              <div style="margin-right: 10px">{{ userInfo.nickname }}</div>-->
                <!--              <el-icon class="el-icon&#45;&#45;right">-->
                <!--                <arrow-down />-->
                <!--              </el-icon>-->
              </div>
            </span>
            <!-- <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :command="0">个人中心</el-dropdown-item>
                <el-dropdown-item v-if="isCreator" :command="1">创作入口</el-dropdown-item>
                <el-dropdown-item :command="2">退出登录</el-dropdown-item>

              </el-dropdown-menu>
            </template> -->
          </el-dropdown>
          <div v-if="isLogin"
            style="width: 40px;height: 40px;background-color: #F2F2F2;border-radius: 100%;display: flex;align-items: center;justify-content: center;cursor: pointer;margin-left: 16px">

            <el-badge v-if="orderCnt > 0" :value="orderCnt" color="#020468" style="margin-top: 8px">
              <img src="../assets/image/order.png" @click="orderDrawer = true" />
            </el-badge>
            <img v-else src="../assets/image/order.png" @click="orderDrawer = true" />
          </div>
        </div>
      </div>

      <el-dialog v-model="loginPop" :show-close="false" width="650px"
        style="z-index: 999; border-radius:10px; padding: 0; position: relative;">
        <img style="position: absolute; top: 0; right: -30px; cursor: pointer;" src="../assets/image/icon-close.png"
          alt="" @click="loginPop = false">
        <img src="../assets/image/login-top.png" alt="">
        <div style="display: flex; height: 370px;">
          <div class="phone-login">
            <div class="title">{{ t('header.phone_login') }}</div>
            <div class="phone">
              <el-input v-model="phone" :placeholder="t('header.enter_phone')" :maxlength="11">
              </el-input>
              <div style="position: absolute; top:15px; left: 14px;font-weight: bold;font-size: 16px;color: #333333;">
                +86
              </div>
            </div>
            <div style="position: relative;">
              <el-input style="margin-top: 20px;" v-model="captcha" :placeholder="t('header.enter_captcha')" :maxlength="6" />
              <div
                style="display: flex; align-items: center; position: absolute; right: 0px; bottom: 0px; cursor: pointer; width: 90px; height: 50px;"
                @click="getCode" v-if="!showCode">
                <div style="width: 1px;height: 16px;background: #E5E5E5; margin-right: 10px;"></div>
                <div style="font-size: 14px;color: #1AB07F;">{{ t('header.get_captcha') }}</div>
              </div>
              <div
                style="display: flex; align-items: center; position: absolute; right: 0px; bottom: 0px; cursor: pointer; width: 90px; height: 50px;"
                v-else>
                <div style="width: 1px;height: 16px;background: #E5E5E5; margin-right: 10px;"></div>
                <div style="font-size: 14px;color: #1AB07F;">{{ num }}{{ t('header.get_captcha_after') }}</div>
              </div>
            </div>
            <el-button color="#1AB07F"
              style="width: 280px;height: 48px; border-radius: 8px; margin-top: 30px; font-size: 16px;"
              @click="onLogin">{{ t('header.login_register') }}</el-button>
            <div style="margin-top: 20px; font-size: 14px;color: #999999; text-align: center;">{{ t('header.agree_terms') }}<span
                style="color: #1AB07F;">{{ t('header.user_agreement') }}</span>和<span style="color: #1AB07F;">{{ t('header.privacy_policy') }}</span><br />{{ t('header.auto_register') }}</div>
          </div>
          <div style="width: 1px;height: 193px;background: #E5E5E5; margin-top: 76px;"></div>
          <div style="width: 280px;display: flex;align-items: center;flex-direction: column">
            <div style="font-weight: bold;font-size: 18px;color: #333333; margin-bottom: 20px; margin-top: 30px;">{{ t('header.wechat_login') }}
            </div>
            <div id="wechatQR"></div>
            <!-- <div style="font-weight: 400;font-size: 14px;color: #999999; margin-top: 20px;">使用微信扫二维码</div> -->
          </div>
        </div>
      </el-dialog>

      <el-dialog v-model="bindingPop" :show-close="false" width="650px"
        style="z-index: 999; border-radius:10px; padding: 0; position: relative; margin-top: 175px;">
        <img style="position: absolute; top: 0; right: -30px; cursor: pointer;" src="../assets/image/icon-close.png"
          alt="" @click="bindingPop = false">
        <img src="../assets/image/login-top.png" alt="">
        <div class="phone-login"
          style="width: 100%; margin:0; display: flex; flex-direction: column; align-items: center;">
          <div style="font-weight: bold;font-size: 14px;color: #333333; margin-top: 20px; margin-bottom: 20px;">
            {{ t('header.bind_phone_security') }}</div>
          <div class="phone">
            <el-input v-model="phone" :placeholder="t('header.enter_phone')" :maxlength="11">
            </el-input>
            <div style="position: absolute; top:15px; left: 14px;font-weight: bold;font-size: 16px;color: #333333;">
              +86
            </div>
          </div>
          <div style="position: relative;">
            <el-input style="margin-top: 20px;" v-model="captcha" :placeholder="t('header.enter_captcha')" :maxlength="6" />
            <div
              style="display: flex; align-items: center; position: absolute; right: 0px; bottom: 0px; cursor: pointer; width: 90px; height: 50px;"
              @click="getCode" v-if="!showCode">
              <div style="width: 1px;height: 16px;background: #E5E5E5; margin-right: 10px;"></div>
              <div style="font-size: 14px;color: #1AB07F;">{{ t('header.get_captcha') }}</div>
            </div>
            <div
              style="display: flex; align-items: center; position: absolute; right: 0px; bottom: 0px; cursor: pointer; width: 90px; height: 50px;"
              v-else>
              <div style="width: 1px;height: 16px;background: #E5E5E5; margin-right: 10px;"></div>
              <div style="font-size: 14px;color: #1AB07F;">{{ num }}{{ t('header.get_captcha_after') }}</div>
            </div>
          </div>
          <el-button color="#1AB07F"
            style="width: 280px;height: 48px; border-radius: 8px; margin-top: 30px; font-size: 16px;"
            @click="onBingding">{{ t('header.bind') }}</el-button>
          <div
            style="margin-top: 20px; font-size: 14px;color: #999999; text-align: center; margin-bottom: 40px; cursor: pointer;"
            @click="bindingPop = false">
            {{ t('header.skip_login') }}
          </div>
        </div>
      </el-dialog>

      <!-- <el-dialog v-model="loginPop" :show-close="false" width="600px" style="padding: 30px">
        <template #header>
          <div style="display: flex;justify-content: space-between;align-items: center">
            <div style="width: 18px;height: 18px"></div>
            <div style="font-size: 20px;font-weight: bold;color: #333">请选择登录方式</div>
            <img @click="loginPop = false" style="cursor: pointer" src="../assets/close.png" alt="">
          </div>
        </template>
        <div>
          <el-tabs v-model="loginType" class="demo-tabs" @tab-change="handleClick">
            <el-tab-pane label="账号" name="账号">
              <div style="margin-top: 20px">
                <el-form size="large" label-position="right" label-width="100px" :model="loginParams"
                  style="max-width: 460px">
                  <el-form-item label="账号">
                    <el-input v-model="loginParams.userName" />
                  </el-form-item>
                  <el-form-item label="密码">
                    <el-input v-model="loginParams.passWord" />
                  </el-form-item>
                  <el-form-item>
                    <el-button style="width: 100%" size="large" type="primary" @click="onSubmit"
                      :loading="isLoading">登录</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="微信" name="微信">
              <div style="width: 100%;display: flex;justify-content: center;align-items: center">
                <div id="wechatQR" style="width: 300px;height: 400px"></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="X" name="X">X</el-tab-pane>
            <el-tab-pane label="Ins" name="Ins">Ins</el-tab-pane>
          </el-tabs>
        </div>
      </el-dialog> -->
    </div>

    <!-- 固定定位的占位符 -->
    <div v-if="isFixed" style="height: 80px;"></div>

    <!-- 菜单容器 -->
    <div ref="menuContainer" :class="{ 'menu-fixed': isFixed, 'top-menu-line': isShowTopLine }"
      style="height: 80px; display: flex; justify-content: center; align-items: center;">
      <div style="position: relative;display: flex">
        <!-- 菜单项 -->
        <div style="display: flex;justify-content: space-between;align-items: center;width: 1200px;">
          <div v-for="(label, index) in menuList" :key="index" @click="changeButton(index, label)"
            @mouseover="selectTabIndex = index" @mouseleave="selectTabIndex = -1" class="menu-item"
            :class="{ 'menu-item-active': buttonIndex == index }" :ref="(el) => setMenuItemRef(el, index)">
            <img style="width: 30px; height: 30px;"
              :src="buttonIndex == index || selectTabIndex == index ? label.selectIcon : label.icon" alt="">
            <div>{{ label.title }}</div>
          </div>
        </div>

        <!-- 高亮背景 -->
        <div class="highlight" :style="highlightStyle"></div>
      </div>
    </div>
    <!-- 订单 -->
    <el-drawer v-model="orderDrawer" :with-header="false">
      <order-view :order-tab-index="orderTabIndex" @cancelOrder="getOrderCount"></order-view>
    </el-drawer>
    <!-- 个人中心 -->
    <el-drawer v-model="userDrawer" :with-header="false">
      <user-info @Layout="userDrawer = false; handleCommand(2)" @onTabItem="jumpLink"></user-info>
    </el-drawer>
  </div>

</template>

<script>
import { ArrowDown, Search } from '@element-plus/icons-vue'
import router from "@/router";
import { ElMessage } from "element-plus";
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import { getUserInfo, login, wxLogin, getOrderList, getCategory, getHomeBanner, phoneLogin, getLoginCode, phoneLoginBound } from "@/api/api";
import { useRoute } from "vue-router/dist/vue-router";
import OrderView from '../views/personal/order.vue'
import UserInfo from '../views/personal/index.vue'
import { treeDataTranslate } from '@/util/index.js'
import sha256 from 'sha256';
import { useI18n } from 'vue-i18n';
export default {
  name: 'HeaderMenu',
  components: {
    ArrowDown,
    Search,
    OrderView,
    UserInfo
  },
  setup() {
    const { t, locale } = useI18n()
    
    const orderCnt = ref(0)
    const orderTabIndex = ref(0)
    const orderDrawer = ref(false)
    const userDrawer = ref(false)
    const menuContainer = ref(null);
    const isFixed = ref(false);
    const offsetTop = ref(0);
    const selectTabIndex = ref(-1)
    const menuList = ref([])
    const categoryRootList = ref([])
    const isRightLinkShow = ref(true)
    const isShowTopLine = ref(false)
    const showQRCode = ref(false)
    // 获取菜单栏距离顶部的位置
    const updateOffsetTop = () => {
      if (menuContainer.value) {
        offsetTop.value = menuContainer.value.getBoundingClientRect().top + window.scrollY;
      }
    };

    // 监听滚动事件
    const handleScroll = () => {
      if (window.scrollY > offsetTop.value - 0) {
        isFixed.value = true;
      } else {
        isFixed.value = false;
      }
    };

    const buttonIndex = ref(0)
    const searchString = ref(undefined)
    const language = ref(localStorage.getItem('language') || 'zh-CN')
    // 与选择的语言保持同步，确保初始渲染正确使用对应语言
    locale.value = language.value
    
    // 构建菜单（首页 + 分类 + 静态项）
    const populateMenu = (rootList = []) => {
      const newMenu = []
      // 首页
      newMenu.push({
        title: t('menu.home'),
        icon: require('../assets/image/sy2.png'),
        selectIcon: require('../assets/image/sy1.png')
      })
      // 分类（沿用接口返回名称）
      for (let a of rootList) {
        const isEn = locale.value === 'en-US'
        const title = isEn ? (a.categoryEnName || a.categoryName) : a.categoryName
        newMenu.push({
          title,
          icon: a.pic,
          selectIcon: a.icon,
          categoryId: a.categoryId
        })
      }
      // 静态菜单项
      newMenu.push({
        title: t('menu.gallery'),
        icon: require('../assets/image/cz2.png'),
        selectIcon: require('../assets/image/cz1.png')
      })
      newMenu.push({
        title: t('menu.creators'),
        icon: require('../assets/image/dp2.png'),
        selectIcon: require('../assets/image/dp1.png')
      })
      newMenu.push({
        title: t('menu.custom'),
        icon: require('../assets/image/dz2.png'),
        selectIcon: require('../assets/image/dz1.png')
      })
      newMenu.push({
        title: t('menu.ai'),
        icon: require('../assets/image/ai1.png'),
        selectIcon: require('../assets/image/ai2.png')
      })
      menuList.value = newMenu
    }

    // 监听语言切换后重建菜单
    watch(language, (newLang) => {
      locale.value = newLang
      localStorage.setItem('language', newLang)
      populateMenu(categoryRootList.value)
    })
    
    const marqueeMessages = ref([
      '加入Seagaa创作者即可获得报酬 了解更多 ➞',
      '加入Seagaa创作者即可获得报酬 了解更多 ➞',
      '加入Seagaa创作者即可获得报酬 了解更多 ➞'
    ]);
    const currentIndex = ref(0);
    setInterval(() => {
      currentIndex.value = (currentIndex.value + 1) % marqueeMessages.value.length;
    }, 3000);
    const loginPop = ref(false)
    const bindingPop = ref(false)
    const isLogin = ref(false)
    const loginType = ref('账号')
    const loginParams = ref({
      // userName: '+8615629080921',
      userName: '+8618702744003',
      passWord: '123456'
    })
    const isLoading = ref(false)
    const isHomePage = ref(false)
    const route = useRoute();
    const isCreator = ref(false)
    const screenWidth = ref(window.innerWidth)
    // watch(() => route.query.code,
    //     (newCode) => {
    //       if (newCode) {
    //         console.log('newCode')
    //         wxLogin({ code: newCode }).then(res => {
    //           console.log(res);
    //         }).catch(res => {});
    //       }
    //     })

    const userInfo = ref({})
    watch(() => route.path, (newPath) => {
      isHomePage.value = newPath === '/'
      if (newPath === '/') {
        buttonIndex.value = 0
        if (route.query.payType && route.query.payType == 1) {
          // console.log('支付成功后回调到这个页面')
          orderDrawer.value = true
          orderTabIndex.value = 10
        }
        if (localStorage.getItem('token')) {
          // 关闭登录弹窗
          loginPop.value = false
          console.log('检测到token，关闭登录弹窗')

          getUserInfo().then(res => {
            if (res) {
              isLogin.value = true
              getOrderList({
                pageNum: 1,
                pageSize: 10,
                orderStatus: 0
              }).then(res => {
                orderCnt.value = res.total
              })
              // 获取完整的查询字符串
              let queryString = window.location.search;

              // 使用URLSearchParams解析查询字符串
              let params = new URLSearchParams(queryString);

              // 获取特定的参数
              let loginType = params.get('loginType');
              if (loginType == 1 && !res.isBounded) {
                bindingPop.value = true
              }
            } else {
              isLogin.value = false
            }
            localStorage.setItem('userInfo', JSON.stringify(res))
            userInfo.value = res
            if (res && res.creatorInfoDtoResp && res.creatorInfoDtoResp.creatorId) {
              console.log('有创作者 ID')
              isCreator.value = true
            }
          }).catch(res => {
            isLogin.value = false
          })
        } else {
          isLogin.value = false
        }
        isRightLinkShow.value = true
      }
      else if (newPath == '/product') {
        // 动态查找“个性定制”菜单项的索引（适配语言）
        const productIndex = menuList.value.findIndex(item => item.title === t('menu.custom'))
        buttonIndex.value = productIndex !== -1 ? productIndex : 9
        isRightLinkShow.value = true
      }
      else if (newPath == '/creatorMore') {
        // 动态查找“店铺”菜单项的索引（适配语言）
        const creatorIndex = menuList.value.findIndex(item => item.title === t('menu.creators'))
        buttonIndex.value = creatorIndex !== -1 ? creatorIndex : 8
        isRightLinkShow.value = true
      } else if (newPath == '/galleryMore') {
        // 动态查找“创作”菜单项的索引（适配语言）
        const galleryIndex = menuList.value.findIndex(item => item.title === t('menu.gallery'))
        buttonIndex.value = galleryIndex !== -1 ? galleryIndex : 7
        isRightLinkShow.value = true
      } else if (newPath == '/hotMore') {
        if (route.query.index) {
          buttonIndex.value = parseInt(route.query.index)
        }
        isRightLinkShow.value = true
      }
      else if (newPath == '/ai') {
        // 动态查找“AI”菜单项的索引（适配语言）
        const aiIndex = menuList.value.findIndex(item => item.title === t('menu.ai'))
        buttonIndex.value = aiIndex !== -1 ? aiIndex : 10
        isRightLinkShow.value = false
      }
      else {
        isRightLinkShow.value = false
        buttonIndex.value = -1
      }

      if (newPath == '/map' || newPath == '/creator' || newPath == '/') {
        isShowTopLine.value = false
      }
      else {
        isShowTopLine.value = true
      }
    }, { immediate: true })
    const hostName = ref('')
    const phone = ref(null)
    const captcha = ref(null)
    onMounted(() => {

      //顶部轮播
      getHomeBanner().then(res => {
        marqueeMessages.value = res.records
      })

      // 创建一个URL对象，这里使用window.location.href作为URL
      const url = new URL(window.location.href);

      // 使用hostname属性获取域名
      hostName.value = url.hostname;
      updateOffsetTop();
      window.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", updateOffsetTop);
      //微信登录，获取 url 的 token 并调用接口登录
      // const code = route.query.code
      // console.log('微信登录，获取到了code',code)
      // if(code) {
      //   wxLogin({code}).then(res => {
      //     console.log(res)
      //   }).catch(res => {});
      //   return
      // }


      if (localStorage.getItem('token')) {

        // getUserInfo().then(res => {
        //   if(res) {
        //     isLogin.value = true
        //   }else {
        //     isLogin.value = false
        //   }
        //   localStorage.setItem('userInfo',JSON.stringify(res))
        //   userInfo.value = res
        //   if(res && res.creatorInfoDtoResp && res.creatorInfoDtoResp.creatorId) {
        //     console.log('有创作者 ID')
        //     isCreator.value = true
        //   }
        // }).catch(res => {
        //   isLogin.value = false
        // })
      } else {
        isLogin.value = false
      }
      getCategory({ shopId: 1 }).then(res => {
        const list = res.filter(a => a.parentId == 0)
        console.log("listlist", list)
        categoryRootList.value = list
        populateMenu(list)
      }).catch(res => { })
    })

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", updateOffsetTop);
    });

    const showCode = ref(false);
    const num = ref(60);
    // 倒数计时
    const countdown = () => {
      showCode.value = true; //验证码
      num.value = 60; //时间s
      let time = setInterval(() => {
        if (num.value > 1) {
          num.value = num.value - 1;
        } else {
          showCode.value = false;
          clearInterval(time);
        }
      }, 1000);
    };

    const getCode = () => {
      if (!/^1[3456789]\d{9}$/.test(phone.value)) {
        ElMessage.error(t('header.invalid_phone_format'));
        return;
      }
      getLoginCode({ number: '+86' + phone.value }).then(res => {
        countdown();
        ElMessage.success(t('header.send_code_success'));
      })
    }

    const onLogin = () => {
      if (!phone.value) {
        ElMessage.error(t('header.please_enter_phone'));
        return
      }
      if (!captcha.value) {
        ElMessage.error(t('header.please_enter_captcha'));
        return
      }
      if (!/^1[3456789]\d{9}$/.test(phone.value)) {
        ElMessage.error(t('header.invalid_phone_format'));
        return;
      }
      phoneLogin({ number: '+86' + phone.value, code: captcha.value }).then(res => {
        // console.log(res)
        localStorage.setItem('token', res.accessToken)
        window.location.reload()
      })
    }

    const onBingding = () => {
      if (!phone.value) {
        ElMessage.error(t('header.please_enter_phone'));
        return
      }
      if (!captcha.value) {
        ElMessage.error(t('header.please_enter_captcha'));
        return
      }
      if (!/^1[3456789]\d{9}$/.test(phone.value)) {
        ElMessage.error(t('header.invalid_phone_format'));
        return;
      }
      phoneLoginBound({ number: '+86' + phone.value, code: captcha.value }).then(res => {
        ElMessage.success(t('header.bind_success'));
        bindingPop.value = false
      }).catch(err => {
        // ElMessage.error(err);
      })
    }

    const handleCommand = (command) => {
      if (command === 0) {
        localStorage.removeItem('personalMenuIndex')
        userDrawer.value = true
        // router.push('/personal')
      } else if (command === 1) {
        router.push({ path: '/creator', query: { t: new Date().getTime() } })
      } else if (command === 2) {
        isLogin.value = false
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        ElMessage({
          message: t('header.logout_success'),
          type: 'success',
        })
        location.reload() // 退出登录后刷新页面
      }
    }

    const getOrderCount = () => {
      getOrderList({
        pageNum: 1,
        pageSize: 10,
        orderStatus: 0
      }).then(res => {
        orderCnt.value = res.total
      })
    }
    const onSubmit = () => {
      isLoading.value = true
      login(loginParams.value).then(res => {
        console.log(res)
        localStorage.setItem('token', res.accessToken)
        window.location.reload()
      }).catch(err => { isLoading.value = false })
    }
    const handleClick = (name) => {
      if (name === '微信') {
        if (window.WxLogin) {
          new window.WxLogin({
            // self_redirect:true,
            id: "wechatQR",
            appid: "wx388226b45c30ffae",
            scope: "snsapi_login",
            redirect_uri: encodeURIComponent('https://' + hostName.value + '/jump'),
            onReady: function (isReady) {
              console.log(isReady);
            }
          });
        }
      }
    }

    const jumpReg = () => {
      console.log(sessionStorage.getItem('isLogin'))
      if (localStorage.getItem('token')) {
        router.push({ path: '/creatorReg', query: { type: '0' } })
      } else {
        ElMessage.error(t('personal.please_login_first'))
      }

    }

    const testLogin = () => {
      isLoading.value = true
      loginParams.value.passWord = sha256(loginParams.value.passWord)
      login(loginParams.value).then(res => {
        console.log(res)
        localStorage.setItem('token', res.accessToken)
        window.location.reload()
      }).catch(err => { isLoading.value = false })
    }
    const openLoginPop = () => {
      loginPop.value = true
      let appid = ''
      if (hostName.value.indexOf('aicqc') === -1) {
        //正式环境
        appid = 'wx388226b45c30ffae'
      } else {
        //测试环境
        appid = 'wx0eacbf485f1e346d'
      }

      nextTick(res => {
        if (window.WxLogin) {
          new window.WxLogin({
            // self_redirect:true,
            id: "wechatQR",
            // appid: "wx388226b45c30ffae", //fungoo 正式环境
            appid, //seagaa 测试环境
            scope: "snsapi_login",
            href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE5MHB4OyBtYXJnaW4tdG9wOjB9Ci5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9Ci5pbXBvd2VyQm94IC5pbmZvIHt3aWR0aDogMTkwcHg7fQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fSA=',
            redirect_uri: encodeURIComponent('https://' + hostName.value + '/jump'),

            onReady: function (isReady) {
              console.log(isReady);
            }
          });
        }
      })

    }

    const changeButton = (index, label) => {
      if (index == 0) {
        buttonIndex.value = index
        router.push('/')
      }
      // else if (index == 1) {
      //   //休闲服
      //   router.push('/hotMore?categoryId=1')
      // }
      // else if (index == 2) {
      //   //想念章
      //   router.push('/hotMore?categoryId=2')
      // }
      // else if (index == 3) {
      //   //爱拼图
      //   router.push('/hotMore?categoryId=3')
      // }
      // else if (index == 4) {
      //   //快乐杯
      //   router.push('/hotMore?categoryId=4')
      // }
      // else if (index == 5) {
      //   //欢乐袋
      //   router.push('/hotMore?categoryId=5')
      // }
      // else if (index == 6) {
      //   //省钱卡
      //   router.push('/hotMore?categoryId=6')
      // }
      else if (label.title == t('menu.gallery')) {
        //创作
        router.push('/galleryMore')
      }
      else if (label.title == t('menu.creators')) {
        //店铺
        router.push('/creatorMore')
      } else if (label.title == t('menu.custom')) {
        //个性定制
        router.push('/product')
      }
      else if (label.title == t('menu.ai')) {
        //AI
        router.push('/ai')
      }
      else {
        buttonIndex.value = index
        router.push('/hotMore?categoryId=' + label.categoryId + '&index=' + index)
      }
    }
    const menuItemRefs = ref([]);
    const setMenuItemRef = (el, index) => {
      if (el) menuItemRefs.value[index] = el;
    };

    const highlightStyle = computed(() => {
      const el = menuItemRefs.value?.[buttonIndex.value];
      if (!el) return { width: '0', left: '0', opacity: 0 };
      const { offsetWidth, offsetLeft } = el;
      return {
        width: `${offsetWidth}px`,
        left: `${offsetLeft}px`,
        opacity: 1,
        transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 0.96)'
      };
    });

    const goTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动
      });
    }

    const jumpLink = (e) => {
      userDrawer.value = false;
      // 获取用户信息中的tabList来确定选项标题
      let userInfo = {}
      if (localStorage.userInfo) {
        userInfo = JSON.parse(localStorage.userInfo)
      }

      // 根据用户信息动态确定选项标题
      let optionTitle = ''
      if (userInfo.creatorInfoDtoResp) {
        // 有创作者信息时的选项顺序
        const titles = ['我的店铺', '我的关注', '我的地址', '我的上传']
        optionTitle = titles[e] || ''
      } else {
        // 没有创作者信息时的选项顺序
        const titles = ['我的关注', '我的地址', '我的上传']
        optionTitle = titles[e] || ''
      }

      // 根据选项标题进行跳转
      if (optionTitle === '我的店铺') {
        router.push({ path: '/creator', query: { t: new Date().getTime() } })
      }
      else if (optionTitle === '我的关注') {
        router.push({ path: '/personal/heart' })
      }
      else if (optionTitle === '我的地址') {
        router.push({ path: '/personal/address' })
      }
      else if (optionTitle === '我的上传') {
        router.push({ path: '/personal/upload' })
      } else {
        //我的积分
        router.push({ path: '/personal/points' })
      }
    }

    const jumpLinkTop = (url) => {
      window.open(url, '_blank')
    }
    return {
      onBingding,
      bindingPop,
      onLogin,
      num,
      showCode,
      getCode,
      phone,
      captcha,
      getOrderCount,
      jumpLinkTop,
      isShowTopLine,
      isRightLinkShow,
      jumpLink,
      userDrawer,
      orderTabIndex,
      selectTabIndex,
      menuList,
      orderDrawer,
      goTop,
      menuItemRefs,
      highlightStyle,
      setMenuItemRef,
      menuContainer,
      isFixed,
      changeButton,
      buttonIndex,
      searchString,
      language,
      Search,
      marqueeMessages,
      currentIndex,
      isHomePage,
      openLoginPop,
      testLogin,
      jumpReg,
      screenWidth,
      isCreator,
      isLoading,
      handleClick,
      onSubmit,
      loginType,
      loginParams,
      isLogin,
      loginPop,
      router,
      route,
      handleCommand,
      userInfo,
      orderCnt,
      showQRCode,
      t,
    }
  }
}

</script>
<style lang="scss" scoped>
.phone-login {
  width: 280px;
  margin-left: 50px;
  margin-right: 40px;

  .title {
    margin-top: 35px;
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 18px;
    color: #333333;
  }

  :deep(.el-input) {
    width: 280px;
    height: 48px;
  }

  :deep(.el-input__wrapper) {
    border-radius: 8px;
    font-size: 16px;
  }

  .phone {
    position: relative;

    :deep(.el-input__wrapper) {
      padding-left: 50px;
    }
  }
}

:deep(.el-drawer) {
  width: 480px !important;
}

.menu-box {
  height: 82px;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-dropdown :focus-visible {
  outline: none;
}

:deep(.el-dialog) {
  border-radius: 30px;
}

:deep(.el-tabs__active-bar) {
  height: 4px;
}

:deep(.el-tabs__item) {
  font-size: 20px;
  font-weight: normal;
}

:deep(.el-tabs__item.is-active, .el-tabs__item:hover) {
  font-size: 20px;
  font-weight: bold;
}

.top-menu-line {
  border-bottom: 1px solid #ccc;
}

.flip-card {
  position: absolute;
  width: 100%;
  height: 36px;
  transform-style: preserve-3d;
  transition: transform 0.6s ease;
}

.flip-content {
  position: absolute;
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #137D5A;
  color: white;
  backface-visibility: hidden;
}

.flip-enter-active .flip-content,
.flip-leave-active .flip-content {
  transition: transform 0.6s ease, opacity 0.6s ease;
  transform-origin: bottom;
}

.flip-enter-from .flip-content {
  transform: rotateX(90deg);
  opacity: 0;
}

.flip-leave-to .flip-content {
  transform: rotateX(-90deg);
  opacity: 0;
}

:deep(.el-select__wrapper) {
  padding: 6px !important;
  background-color: #F2F2F2;
  border: 0 !important;
}

:deep(.el-input__wrapper) {
  border-radius: 30px;
}

:deep(.el-input--large) {
  height: 46px;
}

:deep(.el-input__suffix-inner>:first-child) {
  margin-right: -9px !important;
}

.search-button:hover {
  background-color: #07142c !important;
}

.sel-button {
  background-color: #D4EDFE !important;
  color: #1358BF !important;
}

.menu-fixed {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  background-color: #fff;
  z-index: 999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  /*transition: all 0.3s ease;*/
}

.menu-item {
  position: relative;
  width: 86px;
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  z-index: 1;
}

.menu-item-active {
  color: #1AB07F;
  /* 选中时文字颜色 */
}

.menu-item:hover {
  color: #1AB07F;
  /* 悬停变色 */
}

.highlight {
  position: absolute;
  bottom: 0;
  height: 60px;
  background-color: #E9FFF8;
  z-index: 0;
  pointer-events: none;
  border-radius: 4px;
}

.hover-effect:hover img {
  content: url('../assets/home/kaidian2.png');
  /* 替换为悬停时的图片 */
}

.hover-effect:hover div {
  color: #fff;
  /* 悬停时文字颜色 */
}

.hover-effect {
  transition: background-color 0.3s ease;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.hover-effect:hover {
  background-color: #1AB07F;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.hover-effect2:hover img {
  content: url('../assets/home/dingbu2.png');
  /* 替换为悬停时的图片 */
}

.hover-effect2:hover div {
  color: #fff;
  /* 悬停时文字颜色 */
}

.hover-effect2 {
  transition: background-color 0.3s ease;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.hover-effect2:hover {
  background-color: #1AB07F;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.hover-effect3:hover .kf-img {
  content: url('../assets/home/kf2.png');
  /* 替换为悬停时的图片 */
}

.hover-effect3:hover .kf-text {
  color: #fff;
  /* 悬停时文字颜色 */
}

.hover-effect3 {
  transition: background-color 0.3s ease;
}

.hover-effect3:hover {
  background-color: #1AB07F;
}



.qr-code-overlay {
  text-align: center;
  color: #000;
  background-color: #fff;
  position: absolute;
  left: -20px;
  /* 调整二维码位置 */
  bottom: -196px;
  transform: translateY(-50%) translateX(-100%);
  width: 200px;
  height: 250px;
  padding: 10px;
  //background-image: url('../assets/home/qrcode.png'); /* 替换为实际二维码图片路径 */
  background-size: cover;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  /* 阴影效果 */
  opacity: 0;
  transition: opacity 0.3s ease;
  /* 仅保留透明度变化 */
  pointer-events: none;
  /* 确保二维码不会拦截鼠标事件 */
}

.qr-code-overlay.qr-code-visible {
  opacity: 1;
  /* 悬浮时透明度变为1 */
}

.qr-title {
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  color: #fff;
  background-color: #1AB07F;
  padding: 4px 8px;
  border-radius: 4px;
}

.qr-desc {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #fff;
  background-color: #1AB07F;
  padding: 4px 8px;
  border-radius: 4px;
}
</style>
